import { CertificateRepository, CertificateUploadResponse } from "../repositories/CertificateRepository";

export class UploadCertificateCompanyLogoUseCase {
  constructor(private certificateRepository: CertificateRepository) {}

  async execute(image: File): Promise<CertificateUploadResponse | undefined> {
    const hasBeenUploadedOrUndefined = await this.certificateRepository.uploadLogo(image)
    return hasBeenUploadedOrUndefined
  }
}